import React, { useEffect, useState } from 'react'
import { Navigate, useLocation, useParams } from 'react-router'

import useApplicantTokenOnMount from '@sputnik/hooks/useApplicantTokenOnMount'
import useDivvyUUID from '@sputnik/hooks/useDivvyUUID'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'

import { useGetDecisionAndStatusForPolling } from './GetDecisionAndStatusForPolling.gql'
import ReviewingApplicationPollingPageContent from './ReviewingApplicationPollingPageContent'

const POLLING_MAX_TIMEOUT = 60000
const POLLING_RATE = 3000

const SubmittingApplicationPollingPage = () => {
  /* make sure we have a token before we start polling */
  const { appId } = useParams()
  useApplicantTokenOnMount({ salesforceCreditId: appId || '' })
  const { pathname, search: urlSearch } = useLocation()
  const [hasPollingTimedOut, setHasPollingTimedOut] = useState(false)
  const [companyDivvyUuid] = useDivvyUUID()
  const { data, stopPolling } = useGetDecisionAndStatusForPolling({
    variables: {
      creditApplicationId: appId ?? '',
      companyId: companyDivvyUuid,
    },
    errorPolicy: 'all',
    pollInterval: POLLING_RATE,
    fetchPolicy: 'network-only',
  })

  // save url to redirect back to it in case user leaves this page
  useEffect(() => {
    window.sessionStorage.setItem('submissionPendingUrl', pathname + urlSearch)
  }, [appId, pathname, urlSearch])

  useEffect(() => {
    const timeoutId = setTimeout(() => setHasPollingTimedOut(true), POLLING_MAX_TIMEOUT)
    return () => clearTimeout(timeoutId)
  }, [])

  // navigating away unmounts this page, which also stops polling
  useEffect(() => {
    if (hasPollingTimedOut) stopPolling()
  }, [hasPollingTimedOut, stopPolling])

  if (!data && hasPollingTimedOut) {
    // never received any data, so there is nothing to route on
    return (
      <Navigate
        replace
        to={`/app/${appId}/${PATHNAME_CONSTS.SUBMISSION_ERROR_PATH}`}
      />
    )
  }

  return (
    <ReviewingApplicationPollingPageContent
      decisionAndStatusData={data}
      hasPollingTimedOut={hasPollingTimedOut}
    />
  )
}

export default SubmittingApplicationPollingPage
